import $ from 'jquery';
import I18n from '../i18n/I18n';
import { SELECTORS } from '../constants/selectors';

const UI_COMMANDS_DIALOG_TEMPLATE = `
    <div class="commands-dialog dialog notSelectable">
        <p class="dialog-title" data-i18n="commandsReference.title"></p>
        <div class="dialog-body nice-scrollbar"></div>
        <p class="dialog-footer" data-i18n="commandsReference.scopeHint"></p>
    </div>`;

const COMMAND_SECTIONS = [
    {
        sectionKey: 'departure',
        commands: [
            { id: 'caf', syntax: 'caf' },
            { id: 'cvs', syntax: 'cvs [alt]' },
            { id: 'takeoff', syntax: 'to, /' },
            { id: 'taxi', syntax: 'taxi, w' }
        ]
    },
    {
        sectionKey: 'arrival',
        commands: [
            { id: 'expectRunway', syntax: 'e [rwy]' },
            { id: 'dvs', syntax: 'dvs [alt]' },
            { id: 'ils', syntax: 'i [rwy]' }
        ]
    },
    {
        sectionKey: 'routing',
        commands: [
            { id: 'direct', syntax: 'pd [fix]' },
            { id: 'hold', syntax: 'hold [fix]' },
            { id: 'exitHold', syntax: 'xh' },
            { id: 'route', syntax: 'route [fix]' },
            { id: 'reroute', syntax: 'rr [route]' },
            { id: 'sid', syntax: 'sid [name]' },
            { id: 'star', syntax: 'star [name]' }
        ]
    },
    {
        sectionKey: 'control',
        commands: [
            { id: 'altitude', syntax: 'c/d/a [alt]' },
            { id: 'fph', syntax: 'fph' },
            { id: 'heading', syntax: 't l/r [deg]' },
            { id: 'speed', syntax: '+/- [spd]' },
            { id: 'cross', syntax: 'cr [fix] a[alt] s[spd]' }
        ]
    },
    {
        sectionKey: 'query',
        commands: [
            { id: 'sayAltitude', syntax: 'sa' },
            { id: 'sayAssignedAltitude', syntax: 'saa' },
            { id: 'sayHeading', syntax: 'sh' },
            { id: 'sayAssignedHeading', syntax: 'sah' },
            { id: 'saySpeed', syntax: 'si' },
            { id: 'sayAssignedSpeed', syntax: 'sas' }
        ]
    },
    {
        sectionKey: 'system',
        commands: [
            { id: 'airport', syntax: 'airport [icao]' },
            { id: 'pause', syntax: 'pause' },
            { id: 'timewarp', syntax: 'tw [rate]' },
            { id: 'tutorial', syntax: 'tutorial' }
        ]
    },
    {
        sectionKey: 'scope',
        commands: [
            { id: 'scratchpad', syntax: '. [text]' },
            { id: 'halo', syntax: 'halo' },
            { id: 'moveDataBlock', syntax: '[numpad] [length]' }
        ]
    }
];

/**
 * @class CommandsView
 */
export default class CommandsView {
    /**
     * @constructor
     * @param $element {JQuery|HTML Element}
     */
    constructor($element) {
        this.$element = $element;
        this.$dialog = null;
        this.$dialogBody = null;

        this.init();
    }

    /**
     * @method init
     * @chainable
     */
    init() {
        this.$dialog = $(UI_COMMANDS_DIALOG_TEMPLATE);
        this.$dialogBody = this.$dialog.find(SELECTORS.DOM_SELECTORS.DIALOG_BODY);
        this._buildDialogBody();
        this.$element.append(this.$dialog);
        I18n.applyToDocument(this.$dialog);

        return this;
    }

    /**
     * @method isDialogOpen
     * @return {boolean}
     */
    isDialogOpen() {
        return this.$dialog.hasClass(SELECTORS.CLASSNAMES.OPEN);
    }

    /**
     * @method toggleDialog
     */
    toggleDialog() {
        this.$dialog.toggleClass(SELECTORS.CLASSNAMES.OPEN);
    }

    /**
     * @method refreshTranslations
     */
    refreshTranslations() {
        this._buildDialogBody();
        I18n.applyToDocument(this.$dialog);
    }

    /**
     * @method _buildDialogBody
     * @private
     */
    _buildDialogBody() {
        this.$dialogBody.empty();

        const $intro = $('<p class="commandsReference-intro"></p>');

        $intro.text(I18n.t('commandsReference.intro'));
        this.$dialogBody.append($intro);

        const callsignLabel = I18n.t('commandsReference.callsign');

        COMMAND_SECTIONS.forEach((section) => {
            const $section = $('<section class="commandsReference-section"></section>');
            const $title = $('<h2 class="commandsReference-sectionTitle"></h2>');

            $title.text(I18n.t(`commandsReference.sections.${section.sectionKey}`));
            $section.append($title);

            section.commands.forEach((command) => {
                const $item = $('<div class="commandsReference-item"></div>');
                const $header = $('<div class="commandsReference-itemHeader"></div>');
                const $name = $('<span class="commandsReference-name"></span>');
                const $syntax = $('<code class="commandsReference-syntax"></code>');
                const $desc = $('<p class="commandsReference-desc"></p>');

                $name.text(I18n.t(`commandsReference.items.${command.id}.name`));
                $syntax.text(`${callsignLabel} ${command.syntax}`);
                $desc.text(I18n.t(`commandsReference.items.${command.id}.desc`));

                $header.append($name, $syntax);
                $item.append($header, $desc);
                $section.append($item);
            });

            this.$dialogBody.append($section);
        });
    }
}
